











import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import AppMenu from "@/components/AppMenu/index.vue";

@Component({
  components: { AppMenu },
})
export default class MainView extends Vue {
  /**
   *  We get the subtitle from studio. In case of null or empty variable in store we get it from the json file
   */
  get subtitle(): string {
    return (
      store.state.globalAppDataModule.subTitle ||
      this.$t("components.pageHeader.fallback.subtitle").toString()
    );
  }

  /**
   * We get the chapo from studio.
   */
  get chapo(): string {
    const html = this.$sanitize(store.state.globalAppDataModule.chapo).toString();
    return /^\s*<p[\s>]/i.test(html) ? html.replace(/(<br\s*\/?>\s*)+/gi, "</p><p>") : html;
  }

  // We want to display options panel only in main route, not in suppliers informations or others screen.
  get isMainRoute(): boolean {
    return this.$route.fullPath === "/";
  }
}
